export default __webpack_public_path__ + "static/media/funny, edgy, casual, adult.2f18f9b6.jpeg";